








































































































































import {Component, Watch, Mixins, Vue, Prop} from 'vue-property-decorator'
import {$, PageCollection} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import FilterDeliverySacPublic from '@/components/filters/FilterDeliverySacPublic.vue'
import DeliverySacPublicRequest from '@/model/request/DeliverySacPublicRequest'
import CargaCollection from '@/model/collection/CargaCollection'
import Carga from '@/model/resource/Carga'
import SacResponse from '@/model/response/SacResponse'
import FilterToggle from '@/components/FilterToggle.vue'
import itTrackingSlider from '@/components/itrack/ItTrackingSlider.vue'
import * as Helper from '@/helpers'
import moment from 'moment'
import ModalNotification from '@/components/modals/ModalNotification.vue'
import DeliverySacAttemptResponse from '@/model/resource/DeliverySacAttemptResponse'

enum State {
    INIT = 1,
    SELECTED = 2,
    LISTED = 3,
}

const metaInfo = () => ({
    title: $.t('view.reports.deliverySacPublic.title'),
})

@Component({
    metaInfo,
    components: {ModalNotification, FilterDeliverySacPublic, FilterToggle, itTrackingSlider},
})
export default class ReportsDeliverySacBostonPublicResultView extends Mixins(MixinFilter) {
    @Prop({type: String}) type?: string
    @Prop({type: String, default: null}) token?: string | null

    AppConfig = AppConfig
    State = State
    Helper = Helper

    state = State.INIT

    // Selected item
    model: Carga | null = null
    emptyListTitle: String | null = null

    filter = new DeliverySacPublicRequest()
    filterSac = new DeliverySacPublicRequest()

    collection = new CargaCollection(this.filter, '/user/boston/sac', 10)
    collectionSac = new PageCollection(SacResponse, this.filterSac, null, null)

    showFilter = true
    populateOnMount = false

    queriesToHide: string[] = ['login', 'senha']

    async populate() {
        try {
            await this.query()
        } catch (e) {
            if (e.status === 400) {
                this.emptyListTitle = e.body.message
            }
        }
    }

    updateCarga(val: Carga) {
      if (this.model != null) {
        this.model.idTipoNotificacaoCargaFk = val.idTipoNotificacaoCargaFk
        this.model.observacaoEntrega = val.observacaoEntrega
      }
    }

    @Watch('collection.items', {deep: true})
    listEvent(items: Carga[]) {
        if (!this.filter.isCleared && items.length === 1) {
            this.select(items[0])
        }

        if (items.length === 0) {
            this.emptyListTitle = $.t('view.reports.deliverySacPublic.fragmentDinamicEmptyListNoElements')
        }
    }

    @Watch('state')
    async stateEvent(state: State) {
        if (state === State.LISTED) {
            this.model = null
            this.collectionSac.items = []
        } else if (state === State.SELECTED) {
            await Helper.sleep(1000)

            if (this.model) {
                await this.collectionSac.search()
            }
        } else if (state === State.INIT) {
            this.model = null

            this.filter.clean()
            this.filterSac.clean()

            this.collection.items = []
            this.collectionSac.items = []

            this.showFilter = false
            await this.$nextTick()
            this.showFilter = true
        }
    }

    get eyeIcon() {
        return `<img src="./img/itrack/view-circle-contrast.svg" alt="view-circle">`
    }

    get lastSac() {
        const items = this.collectionSac.items
        return items[items.length - 1]
    }

    list() {
        this.state = State.LISTED
        if (this.filter.dataCriacao != null)  {
            const comp = moment().subtract(3, 'months')
            const  date = moment(this.filter.dataCriacao)
            if (comp.isAfter(date)) {

                this.emptyListTitle = $.t('view.reports.deliverySacPublic.fragmentDinamicEmptyList')
                    + ' ' +  comp.format('DD/MM/YYYY')
            }
        }
    }

    select(model: Carga) {
        this.state = State.SELECTED
        this.model = model
        this.filterSac.danfe = model.danfe
        this.filterSac.nroFiscal = model.nroNotaFiscal
        this.filterSac.idEmbarcador = model.embarcador.responsavel.$id
        this.filterSac.idCarga = model.idCargaPk
    }

    init() {
        this.state = State.INIT
    }

    async backToList() {
      this.filterSac.idCarga = null
      this.filter.idCarga = null
      await this.filtrateSac()
    }

    async filtrateSac() {
        if (this.filter.isCleared) {
            this.init()
        } else {
            this.list()
        }
        await Helper.sleep(1000)
        await this.filtrate()
    }

    async clean() {
        this.filter = new DeliverySacPublicRequest()
        this.filterSac = new DeliverySacPublicRequest()
        await this.filtrateSac()
    }

    async mounted() {
        if (this.filter.isCleared) {
          this.$router.push('/sac/boston')
        }

        this.collectionSac.endpoint = '/user/carga/tentativa/guest'

        try {
            await this.filtrateSac()
        } catch {
            this.$router.replace('/sac')
        }

        if (this.filter.cpfCnpj) {
            this.filter.login = `${this.filter.cpfCnpj}`
        }
    }

  async downloadData() {
    if (this.state === State.SELECTED) {
      this.filter.idCarga = this.filterSac.idCarga
    } else {
      this.filter.idCarga = null
    }
    await $.await.run(() => Helper.downloadXlsx(
      $.t('view.get.deliverySacAttemptResponse.title'),
      '/user/boston/sac/report',
      this.filter,
      DeliverySacAttemptResponse,
      'DeliverySacAttemptResponse',
    ), 'download')
  }
}
